
































































































































































































































































































import { Vue, Prop, Component, Ref } from "vue-property-decorator";
import { ActShort as IAct } from "@/api/models/act-short";
import { Contract as IContract } from "@/api/models/contract";
import api from "@/getinfo-api";
import { Employee as IEmployee } from "@/api/models/employee";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import {
  ActEdit as IActEdit,
  Contractor as IContractor,
  User as IUser
} from "@/api/models";
import DocTemplateGenerate from "@/components/doc-tempates/DocTemplateGenerate.vue";
import Modal from "@/components/form/Modal.vue";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import { generatePdf } from "@/utils/files-helper";

// TODO: пока что для получения полей "Ответственный" и "Договор" приходится обращатсья к апишке, переделать как будут
// возвращать эти поля на бэке
@Component({
  components: {
    EntityFiles,
    DocTemplateGenerateV2,
    Modal,
    DocTemplateGenerate,
    DeleteMaterialModal
  }
})
export default class ActItemPreview extends Vue {
  @Prop() act!: IAct;
  @Ref("modal") modal: any;
  responsible!: IEmployee;
  contract!: IContract;
  showDeleteModal: boolean = false;
  contractor!: IContractor;
  user!: IUser;
  isPdfGeneration: boolean = false;

  data() {
    return {
      contract: undefined,
      responsible: undefined,
      contractor: undefined,
      user: undefined
    };
  }

  async _generatePdf(file: any) {
    this.isPdfGeneration = true;
    const response = await generatePdf(file).catch(
      (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      }
    );
    await this.addFiles([response.id], true);
    this.isPdfGeneration = false;
  }

  async addFiles(files: any, fromDocTemplate: boolean = false) {
    const { data } = await api.ActApi.get(this.act.id);

    let params: IActEdit = {
      contractId: data.contractId,
      number: data.number,
      responsibleId: data.responsibleId!,
      learningResources: data.learningResources,
      signedAt: data.signedAt,
      formedAt: data.formedAt,
      fileIds:
        data.files && fromDocTemplate
          ? [...data.files.map((el: any) => el.id), ...files]
          : [...files],
      price: data.price
    };

    api.ActApi.edit(this.act.id, params).then(res => {
      this.$emit("updateActFiles", res.data);
      this.$store.dispatch("successToast");
    });
  }

  get screenWidth() {
    return window.innerWidth;
  }

  showDeleteForm() {
    this.showDeleteModal = true;
  }

  hideDeleteModal() {
    this.showDeleteModal = false;
  }

  deleteAct() {
    this.showDeleteModal = false;
    api.ActApi._delete(this.act.id)
      .then(() => {
        this.$emit("updateActsList");
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.hideDeleteModal();
      });
  }

  getContractor() {
    if (this.contract.clientId) {
      api.ContractorApi.get(this.contract.clientId).then(
        (res: { data: IContractor }) => {
          this.contractor = res.data;
        }
      );
    }
  }

  getUser() {
    if (this.contract.clientId) {
      api.UsersApi.get(this.contract.clientId).then((res: { data: IUser }) => {
        this.user = res.data;
      });
    }
  }

  async getContract() {
    try {
      if (this.act.contract?.id) {
        let contractResponse = await api.ContractApi.get(this.act.contract?.id);
        this.contract = contractResponse.data;
        if (this.act.responsible && this.act.responsible.id) {
          let responsibleResponse = await api.EmployeeApi.get(
            this.contract.companyId,
            this.act.responsible.id
          );
          this.responsible = responsibleResponse.data;
        }
        this.contract.clientType === "user"
          ? this.getUser()
          : this.getContractor();
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    }
  }

  created() {
    this.getContract();
  }
}
